import {DialogMessage} from "@plugins-fr/dialogMessage";
import {count_add_price_qty} from "@plugins-fr/payment";
import {
    productListingCartModel,
    setCartItem,
    standardInfo
} from "@plugins-fr/script";
import {getParams, shippingCostDisplay} from "@plugins-fr/payment";
import Lang from "@vendors-fr/messages";
import {JconfirmTemplateHelper} from "@plugins-fr/JconfirmTemplateHelper";
import {EventListener} from "@plugins-fr/eventListener";
import {ProductMultipleStandard} from "@plugins-fr/productStandard/productMultipleStandard";
import {doubleStandardHandler} from "@plugins-fr/multipleStandard";
import {ProductDoubleStandard} from "@plugins-fr/productStandard/productDoubleStandard";
import {RetailProduct} from "@plugins-fr/retailProduct";
import {productDetailPriceHelper} from "@plugins-fr/productPrice";
import {PointProduct} from "@plugins-fr/pointProduct";
import {
    exchangeProductPriceListingCartDisplay,
    productPriceListingCartDisplay,
    productStockDisplay
} from "@plugins-fr/productStandard";
import {AddPriceFactory, checkAddPriceQuantity} from "@plugins-fr/retailProductAddPrice";

class ProductStandardToggle
{
    defaultOptions = {
        'mobileSpecificationToggleClass': '',
        'cartItemClass': '.',
        'cartItemQuantityClass': '.',
        'cartItemStandardClass': '.',
        'getProductStandardAjax': '',
    }

    constructor(cartListDom, mobilePushBlockDom, jsVarsThemeStyle, options)
    {
        this.cartListDom = cartListDom;
        this.mobilePushBlockDom = mobilePushBlockDom;
        this.options = Object.assign({}, this.defaultOptions, options);
        this.jsVarsThemeStyle = jsVarsThemeStyle;
    }

    bindEvents()
    {
        this.bindDesktopChangeProductStandardEvent();
        this.bindMobileClickProductsStandardToggleEvent();
    }

    // 更改商品規格(桌機版)
    bindDesktopChangeProductStandardEvent(){}

    // 觸發顯示更改規格的彈窗(手機版)
    bindMobileClickProductsStandardToggleEvent() {}
}
export class NormalProductStandardToggle extends ProductStandardToggle
{
    constructor(cartListDom, mobilePushBlockDom, jsVarsThemeStyle, options)
    {
        super(cartListDom, mobilePushBlockDom, jsVarsThemeStyle, Object.assign({
            'mobileSpecificationToggleClass': '.js_specification_toggle',
            'cartItemClass': '.js_cart_item_list',
            'cartItemQuantityClass': '.js_cart_list_quantity',
            'cartItemStandardClass': '.js_cart_list_standard',
            'getProductStandardAjax': '',
            'isSubscriptionCart': false,
        }, options));
    }

    // 更改商品規格(桌機版)
    bindDesktopChangeProductStandardEvent()
    {
        const _this = this;

        _this.cartListDom.on('click', _this.options.cartItemStandardClass, function () {
            const productId = $(this).data('product_id');
            const originStandardId = $(this).data('origin_standard_id');
            const originQuantity = $(this).data('origin_quantity');
            const isLiveShopping168 = $(this).data('is-liveshopping168') == 1;
            const addPriceDom = $(this).closest(_this.options.cartItemClass).find('.js_cart_list_add_price_quantity');

            productListingCartModel(
                function(){
                    let response = this.ajaxResponse.data;
                    if (!response.status) {
                        return false;
                    }

                    const listingCartModel = this;
                    const modelContent = listingCartModel.$content;
                    const successBtnDom = modelContent.find('.js_btn_success_change');
                    const cancelBtnDom = modelContent.find('.js_btn_close_change');

                    const eventListener = new EventListener();
                    const productStandard = _this.buildProductStandard(modelContent, productId, eventListener, response);

                    if (!productStandard) {
                        listingCartModel.close();
                        new DialogMessage({
                            'title': '系統忙碌中，請稍後再試。',
                        }, {
                            'closeTimeout': 5000
                        }).handle();
                        return false;
                    }

                    const product = new RetailProduct(modelContent, productStandard, eventListener, {
                        currencyIcon: response.currencyIcon,
                        customCurrency: response.customCurrency,
                    });
                    product.setPriceDisplay(productPriceListingCartDisplay);
                    product.setStockDisplay(productStockDisplay);
                    product.bindEvents();
                    productStandard.updateStandardByStandardId(originStandardId);
                    product.refreshProductQuantity(originQuantity);

                    // 點擊確定
                    successBtnDom.off('click');
                    successBtnDom.click(() => {
                        const standardId = productStandard.getStandardId();

                        if (standardId === 0) {
                            new DialogMessage({
                                'title': Lang.get('frontend.product.title.plz.selectstyle'),
                            }, {
                                'closeTimeout': 5000
                            }).handle();
                            return false;
                        }

                        let mainQty = modelContent.find('.js_product_qty:visible').val();
                        let addPriceQty = count_add_price_qty(originStandardId);

                        if (!_this.checkRetailAddPriceQuantityByStandardId(originStandardId, mainQty, _this.getRetailAddPriceItemsByStandardId(originStandardId))) {
                            return false;
                        }

                        let params = getParams();
                        params.origin_standard_id = originStandardId;
                        params.standard_id = standardId;
                        params.product_id = productId;
                        params.qty = mainQty;

                        const changeCartItemStandardAction = () => {
                            params.removeItemAddprices = 'n';
                            if (addPriceDom.length > 0) {
                                const addPrice = _this.getAddPrice(addPriceDom);
                                params.add_add_prices = Object.assign({}, addPrice.addAddPrices);
                                params.removeItemAddprices = 'y';
                            }

                            setCartItem('update_cart_item_standard', params, shippingCostDisplay, false);
                            listingCartModel.close();
                        };

                        if (isLiveShopping168) {
                            _this.popupLiveShopping168Model(changeCartItemStandardAction);
                        } else {
                            changeCartItemStandardAction();
                        }
                    });

                    // 點擊取消
                    cancelBtnDom.click(() => {
                        this.close();
                    });

                    modelContent.find('.js_btn_success_change, .js_btn_close_change').hover(
                        function () {
                            $(this).attr('style', $(this).data('hover-style'));
                        },
                        function () {
                            $(this).attr('style', $(this).data('style'));
                        }
                    );

                    $('#js_mask_cover').hide();
                    setTimeout(function(){
                        $('#js_mask_cover').show();
                    }, 1000);
                },
                function () {
                    return _this.fetchDesktopListingCartModel(this, productId);
                }
            );
        });
    }

    // 觸發顯示更改規格的彈窗(手機版)
    bindMobileClickProductsStandardToggleEvent()
    {
        const _this = this;

        _this.cartListDom.on('click', _this.options.mobileSpecificationToggleClass, function (e) {
            e.preventDefault;
            const standardDom = $(this).parent().find(_this.options.cartItemStandardClass);
            const productId = standardDom.data('product_id');
            const originStandardId = standardDom.data('origin_standard_id');
            const originQuantity = standardDom.data('origin_quantity');
            const isLiveShopping168 = standardDom.data('is-liveshopping168') == 1;
            const addPriceDom = standardDom.closest(_this.options.cartItemClass).find('.js_cart_list_add_price_quantity');

            $.ajax({
                url: _this.options.getProductStandardAjax,
                type: 'POST',
                dataType: 'json',
                data: {
                    standard_id: originStandardId,
                    quantity: originQuantity,
                },
                success:function(response) {
                    if (!response.status && response.message) {

                        new DialogMessage({
                            'icon': 'icon-new_exclaim_circle',
                            'title': response.message,
                        }, {
                            'closeTimeout': 5000
                        }).handle();

                        return false;
                    }

                    _this.mobilePushBlockDom.html(response.CartSpecificationBlockHtml);

                    let slideBottom = new Menu({
                        type: 'push_specification'
                    });

                    const modelContent = _this.mobilePushBlockDom;
                    const eventListener = new EventListener();
                    const productStandard = _this.buildProductStandard(modelContent, productId, eventListener, response);

                    if (!productStandard) {
                        modelContent.html('');
                        slideBottom.close();
                        new DialogMessage({
                            'title': '系統忙碌中，請稍後再試。',
                        }, {
                            'closeTimeout': 5000
                        }).handle();
                        return false;
                    }

                    productDetailPriceHelper.setPrice(response.productDisplayPrices);
                    productDetailPriceHelper.setStandards(response.standards);
                    productDetailPriceHelper.init();

                    const product = new RetailProduct(modelContent, productStandard, eventListener, {
                        currencyIcon: response.currencyIcon
                    });
                    product.setPriceDisplay({
                        build(retailProduct) {
                            productDetailPriceHelper.updatePrice(retailProduct.productStandard.getStandardId());
                        }
                    })
                    product.setStockDisplay(productStockDisplay);
                    product.bindEvents();
                    productStandard.updateStandardByStandardId(originStandardId);
                    product.refreshProductQuantity(originQuantity);
                    slideBottom.open();

                    // 點擊確定
                    modelContent.find('.js_add_cart').off('click');
                    modelContent.find('.js_add_cart').click(() => {
                        const standardId = productStandard.getStandardId();

                        if (standardId === 0) {
                            new DialogMessage({
                                'title': Lang.get('frontend.product.title.plz.selectstyle'),
                            }, {
                                'closeTimeout': 5000
                            }).handle();
                            return false;
                        }

                        let mainQty = modelContent.find('.js_product_qty').val();
                        let addPriceQty = count_add_price_qty(originStandardId);

                        if (! _this.checkRetailAddPriceQuantityByStandardId(originStandardId, mainQty, _this.getRetailAddPriceItemsByStandardId(originStandardId))) {
                            return false;
                        }

                        let params = getParams();
                        params.origin_standard_id = originStandardId;
                        params.standard_id = standardId;
                        params.product_id = productId;
                        params.qty = mainQty;

                        const changeCartItemStandardAction = () => {
                            params.removeItemAddprices = 'n';
                            if (addPriceDom.length > 0) {
                                const addPrice = _this.getAddPrice(addPriceDom);
                                params.add_add_prices = Object.assign({}, addPrice.addAddPrices);
                                params.removeItemAddprices = 'y';
                            }

                            setCartItem('update_cart_item_standard', params, shippingCostDisplay, false);
                            slideBottom.close();
                            modelContent.html('');
                        };

                        if (isLiveShopping168) {
                            _this.popupLiveShopping168Model(changeCartItemStandardAction);
                        } else {
                            changeCartItemStandardAction();
                        }
                    });
                },
                error:function() {
                    throw new Error("Can't get mobile product standard.");
                },
            });
        });
    }

    fetchDesktopListingCartModel(model, productId) {
        const _this = this;

        return $.ajax({
            url: locale + '/product/listingCart',
            dataType: 'json',
            method: 'POST',
            data: {
                'productId': productId,
                'action': 'changeRetailProduct'
            }
        }).done(function (response) {
            if (!response.status) {
                model.setContentAppend(model.errorMessage);
                return false;
            }

            let contentDom = $(response.view);
            model.setContentAppend(contentDom);
            _this.mobilePushBlockDom.html('');
            return true;

        }).fail(function () {
            model.setContentAppend(model.errorMessage);
        });
    }

    popupLiveShopping168Model(confirmCallback) {
        const _this = this;
        $.confirm({
            template: JconfirmTemplateHelper.getTemplate({
                'templateType': '01',
                'theme': 'el_confirm'
            }),
            columnClass: 'col-lg-5 col-xl-4',
            content: false,
            closeIcon: false,
            icon: 'icon-new_exclaim_circle',
            title: Lang.get('frontend.cart.liveShopping168.confirm.changeStandard'),
            buttons: {
                confirmButton: {
                    text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.success') + '</span>',
                    btnClass: 'btn_confirm btn el_btn md solid el_rounded el_text m-0',
                    action: confirmCallback
                },
                cancelButton: {
                    text: '<span class="el_text_inner">'+ Lang.get('frontend.other.btn.cancel') + '</span>',
                    btnClass: 'btn_cancel btn el_btn md solid el_rounded el_text order-1 m-0',
                }
            },
            onOpenBefore: function() {
                this.$el.find('.btn_confirm').attr('style', _this.jsVarsThemeStyle.confirmButtonStyle);
                this.$el.find('.btn_confirm').data('style', _this.jsVarsThemeStyle.confirmButtonStyle);
                this.$el.find('.btn_confirm').data('hover-style', _this.jsVarsThemeStyle.confirmButtonHoverStyle);

                this.$el.find('.btn_cancel').attr('style', _this.jsVarsThemeStyle.cancelButtonStyle);
                this.$el.find('.btn_cancel').data('style', _this.jsVarsThemeStyle.cancelButtonStyle);
                this.$el.find('.btn_cancel').data('hover-style', _this.jsVarsThemeStyle.cancelButtonHoverStyle);

                this.$el.find('.btn_confirm, .btn_cancel').hover(
                    function () {
                        $(this).attr('style', $(this).data('hover-style'));
                    },
                    function () {
                        $(this).attr('style', $(this).data('style'));
                    }
                );
            }
        });
    }

    getAddPrice(addPriceDom) {
        let allAddPricesId = [];
        let addAddPrices = [];

        addPriceDom.each(function () {
            let addPriceId = String($(this).data('add-price-id')),
                addPriceStandardId = String($(this).data('add-price-standard-id')),
                addPriceQty = $(this).data('origin-qty'),
                addAddPrice = {};

            allAddPricesId.push(addPriceId + addPriceStandardId);

            addAddPrice = {
                id: addPriceId,
                standard_id: addPriceStandardId,
                quantity: addPriceQty,
            };

            addAddPrices.push(addAddPrice);

        });

        return {
            'addAddPrices': addAddPrices,
            'allAddPricesId': allAddPricesId,
        }
    }

    buildProductStandard(content, productId, eventListener, response) {
        let productStandard = null;
        if (response.standardType === '1') {
            productStandard = new ProductMultipleStandard(content, eventListener, {
                productDisplayPrices: response.productDisplayPrices
            });
        } else if (response.standardType === '2') {
            const temp = (new doubleStandardHandler(response.standards));
            temp.init();
            standardInfo.set(productId, temp);

            productStandard = new ProductDoubleStandard(content, eventListener, {
                productId: productId,
                productDisplayPrices: response.productDisplayPrices,
                mainStockMap: response.mainStockMap,
                subStockMap: response.subStockMap,
                standardInfo: standardInfo,

            });
        }

        return productStandard;
    }


    checkRetailAddPriceQuantityByStandardId(standardId, mainItemQuantity, addPriceList) {
        const addPriceCondition = this.getRetailAddPricePurchaseConditionByStandardId(standardId);
        const addPriceItems = AddPriceFactory.buildAddPriceItemList(addPriceList);
        const check = checkAddPriceQuantity(mainItemQuantity, addPriceItems, addPriceCondition);

        if (! check.status) {
            new DialogMessage({
                'title': check.errorMessage,
            }).handle();
        }

        return check.status;
    }

    getRetailAddPricePurchaseConditionByStandardId(standardId) {
        const condition = $('.js_cart_item_list[data-standard-id="'+standardId+'"]').find('.js_retail_addprice_purchase_condition').val();
        const maxLimit = $('.js_cart_item_list[data-standard-id="'+standardId+'"]').find('.js_retail_addprice_purchase_condition_maxlimit').val();
        return AddPriceFactory.buildAddPriceConditions(condition, maxLimit);
    }

    getRetailAddPriceItemsByStandardId(standardId) {
        let addPrices = [];
        $(".js_cart_list_add_price_quantity[data-standard-id=" + standardId + "]").each(function(){
            addPrices.push({
                'standard_id': $(this).attr('data-add-price-standard-id'),
                'quantity': $(this).val(),
            });
        });

        return addPrices;
    }
}

export class ExchangeProductStandardToggle extends ProductStandardToggle
{

    constructor(cartListDom, mobilePushBlockDom, jsVarsThemeStyle, options)
    {
        super(cartListDom, mobilePushBlockDom, jsVarsThemeStyle, Object.assign({
            'mobileSpecificationToggleClass': '.js_exchange_specification_toggle',
            'cartItemClass': '.js_cart_exchange_item_list',
            'cartItemQuantityClass': '.js_cart_exchange_quantity',
            'cartItemStandardClass': '.js_cart_exchange_standard',
            'getProductStandardAjax': '',
        }, options));
    }

    // 更改商品規格(桌機版)
    bindDesktopChangeProductStandardEvent()
    {
        const _this = this;

        _this.cartListDom.on('click', _this.options.cartItemStandardClass, function () {
            const productId = $(this).data('product_id');
            const originStandardId = $(this).data('origin_standard_id');
            const originQuantity = $(this).data('origin_quantity');

            productListingCartModel(
                function(){
                    let response = this.ajaxResponse.data;
                    if (!response.status) {
                        return false;
                    }

                    const listingCartModel = this;
                    const modelContent = listingCartModel.$content;
                    const successBtnDom = modelContent.find('.js_btn_success_change');
                    const cancelBtnDom = modelContent.find('.js_btn_close_change');

                    const eventListener = new EventListener();
                    const productStandard = _this.buildProductStandard(modelContent, productId, eventListener, response);

                    if (!productStandard) {
                        listingCartModel.close();
                        new DialogMessage({
                            'title': '系統忙碌中，請稍後再試。',
                        }, {
                            'closeTimeout': 5000
                        }).handle();
                        return false;
                    }

                    const product = new PointProduct(modelContent, productStandard, eventListener, {
                        pointUnit: response.pointUnit
                    });
                    product.setPriceDisplay(exchangeProductPriceListingCartDisplay);
                    product.setStockDisplay(productStockDisplay);
                    product.bindEvents();
                    productStandard.updateStandardByStandardId(originStandardId);
                    product.refreshProductQuantity(originQuantity);

                    // 點擊確定
                    successBtnDom.off('click');
                    successBtnDom.click(() => {
                        const standardId = productStandard.getStandardId();

                        if (standardId === 0) {
                            new DialogMessage({
                                'title': Lang.get('frontend.product.title.plz.selectstyle'),
                            }, {
                                'closeTimeout': 5000
                            }).handle();
                            return false;
                        }

                        let mainQty = modelContent.find('.js_product_qty:visible').val();

                        let params = getParams();
                        params.origin_standard_id = originStandardId;
                        params.standard_id = standardId;
                        params.product_id = productId;
                        params.qty = mainQty;

                        const changeCartItemStandardAction = () => {

                            setCartItem('update_exchange_item_standard', params, shippingCostDisplay, false);
                            listingCartModel.close();
                        };

                        changeCartItemStandardAction();
                    });

                    // 點擊取消
                    cancelBtnDom.click(() => {
                        this.close();
                    });

                    modelContent.find('.js_btn_success_change, .js_btn_close_change').hover(
                        function () {
                            $(this).attr('style', $(this).data('hover-style'));
                        },
                        function () {
                            $(this).attr('style', $(this).data('style'));
                        }
                    );

                    $('#js_mask_cover').hide();
                    setTimeout(function(){
                        $('#js_mask_cover').show();
                    }, 1000);
                },
                function () {
                    return _this.fetchDesktopListingCartModel(this, productId);
                }
            );
        });
    }

    // 觸發顯示更改規格的彈窗(手機版)
    bindMobileClickProductsStandardToggleEvent()
    {
        const _this = this;

        _this.cartListDom.on('click', _this.options.mobileSpecificationToggleClass, function (e) {
            e.preventDefault;

            const standardDom = $(this).parent().find(_this.options.cartItemStandardClass);
            const productId = standardDom.data('product_id');
            const originStandardId = standardDom.data('origin_standard_id');
            const originQuantity = standardDom.data('origin_quantity');

            // const qtyDom = $(this).closest(_this.options.cartItemClass).find(_this.options.cartItemQuantityClass);
            // const optionSelectedDom = $(_this.options.cartItemStandardClass + ' option:selected');
            // let productId = $(this).closest(_this.options.cartItemClass).find(_this.options.cartItemStandardClass).data('product_id');
            // let standardId = qtyDom.data('standard-id');
            // let qty = qtyDom.val();

            $.ajax({
                url: _this.options.getProductStandardAjax,
                type: 'POST',
                dataType: 'json',
                data: {
                    standard_id: originStandardId,
                    quantity: originQuantity,
                },
                success:function(response) {
                    if (!response.status && response.message) {

                        new DialogMessage({
                            'icon': 'icon-new_exclaim_circle',
                            'title': response.message,
                        }, {
                            'closeTimeout': 5000
                        }).handle();

                        return false;
                    }

                    _this.mobilePushBlockDom.html(response.CartSpecificationBlockHtml);

                    let slideBottom = new Menu({
                        type: 'push_specification'
                    });

                    const modelContent = _this.mobilePushBlockDom;
                    const eventListener = new EventListener();
                    const productStandard = _this.buildProductStandard(modelContent, productId, eventListener, response);

                    if (!productStandard) {
                        slideBottom.close();
                        _this.mobilePushBlockDom.html('');
                        new DialogMessage({
                            'title': '系統忙碌中，請稍後再試。',
                        }, {
                            'closeTimeout': 5000
                        }).handle();
                        return false;
                    }

                    const product = new PointProduct(modelContent, productStandard, eventListener, {
                        pointUnit: response.pointUnit
                    });
                    product.setPriceDisplay({
                        build(retailProduct) {
                            $('.js_frontend_price_area').addClass('d-none');
                            $('#js_product_price_' + retailProduct.productStandard.getStandardId()).removeClass('d-none');
                        }
                    })
                    product.setStockDisplay(productStockDisplay);
                    product.bindEvents();
                    productStandard.updateStandardByStandardId(originStandardId);
                    product.refreshProductQuantity(originQuantity);
                    slideBottom.open();

                    // 點擊確定
                    modelContent.find('.js_add_cart').off('click');
                    modelContent.find('.js_add_cart').click(() => {
                        const standardId = productStandard.getStandardId();

                        if (standardId === 0) {
                            new DialogMessage({
                                'title': Lang.get('frontend.product.title.plz.selectstyle'),
                            }, {
                                'closeTimeout': 5000
                            }).handle();
                            return false;
                        }

                        let mainQty = modelContent.find('.js_product_qty').val();


                        let params = getParams();
                        params.origin_standard_id = originStandardId;
                        params.standard_id = standardId;
                        params.product_id = productId;
                        params.qty = mainQty;

                        const changeCartItemStandardAction = () => {
                            setCartItem('update_exchange_item_standard', params, shippingCostDisplay, false);
                            slideBottom.close();
                            _this.mobilePushBlockDom.html('');
                        };

                        changeCartItemStandardAction();
                    });
                },
                error:function() {
                    throw new Error("Can't get mobile product standard.");
                },
            });
        });
    }

    fetchDesktopListingCartModel(model, productId) {
        const _this = this;
        return $.ajax({
            url: locale + '/product/exchangeProductListingCart',
            dataType: 'json',
            method: 'POST',
            data: {
                'productId': productId,
                'action': 'changeExchangeProduct'
            }
        }).done(function (response) {
            if (!response.status) {
                model.setContentAppend(model.errorMessage);
                return false;
            }

            let contentDom = $(response.view);
            model.setContentAppend(contentDom);
            _this.mobilePushBlockDom.html('');
            return true;

        }).fail(function () {
            model.setContentAppend(model.errorMessage);
        });
    }

    buildProductStandard(content, productId, eventListener, response) {
        let productStandard = null;
        if (response.standardType === '1') {
            productStandard = new ProductMultipleStandard(content, eventListener, {
                productDisplayPrices: response.productDisplayPoints
            });
        } else if (response.standardType === '2') {
            const temp = (new doubleStandardHandler(response.standards));
            temp.init();
            standardInfo.set(productId, temp);

            productStandard = new ProductDoubleStandard(content, eventListener, {
                productId: productId,
                productDisplayPrices: response.productDisplayPoints,
                mainStockMap: response.mainStockMap,
                subStockMap: response.subStockMap,
                standardInfo: standardInfo,

            });
        }

        return productStandard;
    }
}
